/* =============================================================
 * import
 * ========================================================== */
import Swiper from 'swiper/bundle';
import {mediaQuery} from "../utils/utils";

/* =============================================================
 * function
 * ========================================================== */
let swiperBrand;
let swiperNextOneMain;
let swiperNextOneSub;
let swiperFeatures;
let swiperHandlingMain;
let swiperHandlingSub;
let swiperHandlingThird;
let swiperUpcomingMain;
let swiperUpcomingSub;

export function brandSwiper(data) {

  const swipeContent = data.next.container.querySelector('.brand_contents_swiper');
  // const windowWidth = window.innerWidth;

  if (swipeContent) {

    const slidesCount = swipeContent.querySelectorAll('.swiper-slide').length;  // スライドの数を取得
    const initSwiper = () => {
      swiperBrand = new Swiper('.brand_contents_swiper', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: "auto", // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        slidesPerGroup: 1,
        speed: 1200, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: false,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 16,
        grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        freeMode: {
          enabled: true, // true：自由にドラッグ（スワイプ）できるようにする。
          momentum: true, // 有効にすると、スライドを離した後もしばらくの間、スライドが動き続けます
          momentumRatio: 1, // 数字が大きいほど惰性スクロールの距離が伸びる（freeMode: trueとfreeModeMomentum:trueが前提）
          momentumVelocityRatio: 1, // 数字が大きいほど惰性スクロールのスピードが速くなる（freeMode: trueとfreeModeMomentum:trueが前提）
          sticky: false,  // スライド位置へのスナップの有効無効
        },
        scrollbar: {
          el: '.swiper-scrollbar', // スクロールバー要素のクラス
          draggable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },

        /*
        on: {
          progress: function () {
            rotateSlider(this);
          },
          init: function () {
            updateCustomClasses(this);
          },
          slideChange: function () {
            updateCustomClasses(this);
          },
        },
        */
      });

      /*
      swipeContent.addEventListener("mouseenter", function() {
        cursor.classList.add('active_swipe');
      });

      swipeContent.addEventListener("mouseleave", function() {
        cursor.classList.remove('active_swipe');
      });
      */
    };


    const destroySwiper = () => {
      if (swiperBrand && typeof swiperBrand.destroy === 'function') {
        swiperBrand.destroy(true, true);
        swiperBrand = null;
        // cursor.classList.remove('active_swipe');
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiperBrand) {
        if (slidesCount > 3 && mediaQuery() !== 'sp' || slidesCount > 1 && mediaQuery() === 'sp') {
          initSwiper();
        }
      }
    };

    handleSwiper();

  }
}


export function nextOneSwiper(data) {

  const swipeContentMain = data.next.container.querySelector('.kv_swiper_main');
  // const swipeContentSub = data.next.container.querySelector('.kv_swiper_sub');  // スライドの数によっては存在しない可能性あり。

  if (swipeContentMain) {

    const slidesCountMain = swipeContentMain.querySelectorAll('.swiper-slide').length;  // スライドの数を取得
    // const slidesCountSub = swipeContentSub.querySelectorAll('.swiper-slide').length;  // スライドの数を取得

    const initSwiper = () => {
      swiperNextOneSub = new Swiper('.kv_swiper_sub', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: true,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
      });

      swiperNextOneMain = new Swiper('.kv_swiper_main', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: true,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        navigation: {
          nextEl: '.kv_slider_sub',
          // prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          totalClass: 'swiper-pagination-total kv_slider_pager_num',
          currentClass: 'swiper-pagination-current kv_slider_pager_num current',
          formatFractionTotal: function(total) {
            // 以下、スライド枚数が2枚の場合、WP側で2重に出力することでloopを実現しているため、特殊な処理で調整。
            if (swipeContentMain.classList.contains('double_loop')) {
              // スライドの数が2の場合、1を返す
              return (total === 4) ? 2 : total;
            } else if (swipeContentMain.classList.contains('double_loop_ver3')) {
              // スライドの数が3の場合、4~6を別々に処理
              if (total === 4) {
                return 1;
              } else if (total === 5) {
                return 2;
              } else if (total === 6) {
                return 3;
              }
            }
            return total;
          },
          formatFractionCurrent: function(number) {
            // 以下、スライド枚数が2枚の場合、WP側で2重に出力することでloopを実現しているため、特殊な処理で調整。
            if (swipeContentMain.classList.contains('double_loop')) {
              // スライドの数が2の場合、3と4を別々に処理
              if (number === 3) {
                return 1;
              } else if (number === 4) {
                return 2;
              }
            } else if (swipeContentMain.classList.contains('double_loop_ver3')) {
              // スライドの数が3の場合、4と5と6を別々に処理
              if (number === 4) {
                return 1;
              } else if (number === 5) {
                return 2;
              } else if (number === 6) {
                return 3;
              }
            }
            return number;
          },
        },
        parallax: true,
      });

      swiperNextOneMain.controller.control = [swiperNextOneSub];
      swiperNextOneSub.controller.control = [swiperNextOneMain];
    };


    const destroySwiper = () => {
      if (swiperNextOneMain && typeof swiperNextOneMain.destroy === 'function') {
        swiperNextOneMain.destroy(true, true);
        swiperNextOneMain = null;
      }

      if (swiperNextOneSub && typeof swiperNextOneSub.destroy === 'function') {
        swiperNextOneSub.destroy(true, true);
        swiperNextOneSub = null;
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiperNextOneMain) {
        if (slidesCountMain > 1) {
          initSwiper();
        }
      }
    };

    handleSwiper();
  }
}


export function featuresSwiper(data) {

  const swipeContent = data.next.container.querySelector('.features_swiper');
  // const windowWidth = window.innerWidth;

  if (swipeContent) {

    // const slidesCount = swipeContent.querySelectorAll('.swiper-slide').length;  // スライドの数を取得
    const initSwiper = () => {
      swiperFeatures = new Swiper('.features_swiper', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: "auto", // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        // slidesPerGroup: 1,
        speed: 600, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        effect: 'cards',
        cardsEffect: {
          perSlideRotate: 5,
          perSlideOffset: 12,
        },

        on: {
          slideChange: function() {
            const activeIndex = this.realIndex; // 現在のアクティブなスライドのインデックス
            document.querySelectorAll('.home_features_list_item').forEach((item, index) => {
              if (index === activeIndex) {
                item.classList.add('is-active'); // アクティブなスライドに対応する要素にクラスを付与
              } else {
                item.classList.remove('is-active'); // アクティブでないスライドにはクラスを削除
              }
            });
          },
        },

      });

      // クリックした要素に応じて対応するスライドまでスワイプする
      document.querySelectorAll('.home_features_list_item').forEach((item, index) => {
        item.addEventListener('click', () => {
          swiperFeatures.slideToLoop(index); // スライドのインデックスは1から始まるため、+1する
        });
      });
    };


    const destroySwiper = () => {
      if (swiperFeatures && typeof swiperFeatures.destroy === 'function') {
        swiperFeatures.destroy(true, true);
        swiperFeatures = null;
        // cursor.classList.remove('active_swipe');
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiperFeatures) {
        if (mediaQuery() !== 'sp') {
          initSwiper();
        }
      }
    };

    // ブレークポイントでのイベントリスナーを追加
    window.addEventListener('resize', handleSwiper);

    // 初期化
    handleSwiper();
  }
}


export function handlingSwiper(data) {

  const swipeContentMain = data.next.container.querySelector('.handling_swiper_main');
  // const swipeContentSub = data.next.container.querySelector('.handling_swiper_sub');  // スライドの数によっては存在しない可能性あり。
  // const swipeContentThird = data.next.container.querySelector('.handling_swiper_third');  // スライドの数によっては存在しない可能性あり。

  if (swipeContentMain) {

    const slidesCountMain = swipeContentMain.querySelectorAll('.swiper-slide').length;  // スライドの数を取得
    // const slidesCountSub = swipeContentSub.querySelectorAll('.swiper-slide').length;  // スライドの数を取得

    const initSwiper = () => {
      swiperHandlingThird = new Swiper('.handling_swiper_third', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
      });

      swiperHandlingSub = new Swiper('.handling_swiper_sub', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
      });

      swiperHandlingMain = new Swiper('.handling_swiper_main', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
        longSwipes: true,
        longSwipesRatio: .1,
        autoplay: {
          delay: 8000,  // 自動再生の間隔
          pauseOnMouseEnter: true, // マウスを乗せている間は自動再生を止める（true）
          disableOnInteraction: false,  // 一度でも操作すると自動再生を止める（true）
        },
      });

      swiperHandlingMain.controller.control = [swiperHandlingSub, swiperHandlingThird];
      swiperHandlingSub.controller.control = [swiperHandlingMain, swiperHandlingThird];
      // swiperHandlingThird.controller.control = [swiperHandlingMain, swiperHandlingSub]; // エラーが出る

      swiperHandlingThird.on('beforeTransitionStart', function() {
        if (swiperHandlingSub && typeof swiperHandlingSub.slideToLoop === 'function') {
          swiperHandlingSub.slideToLoop(this.realIndex, undefined, false);
        }
        if (swiperHandlingMain && typeof swiperHandlingMain.slideToLoop === 'function') {
          swiperHandlingMain.slideToLoop(this.realIndex, undefined, false);
        }
      });

    };


    const destroySwiper = () => {
      if (swiperHandlingMain && typeof swiperHandlingMain.destroy === 'function') {
        swiperHandlingMain.destroy(true, true);
        swiperHandlingMain = null;
      }

      if (swiperHandlingSub && typeof swiperHandlingSub.destroy === 'function') {
        swiperHandlingSub.destroy(true, true);
        swiperHandlingSub = null;
      }

      if (swiperHandlingThird && typeof swiperHandlingThird.destroy === 'function') {
        swiperHandlingThird.destroy(true, true);
        swiperHandlingThird = null;
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiperHandlingMain) {
        if (slidesCountMain > 1) {
          initSwiper();
        }
      }
    };

    handleSwiper();
  }
}


export function upcomingSwiper(data) {

  const swipeContentMain = data.next.container.querySelector('.upcoming_swiper_main');
  // const swipeContentSub = data.next.container.querySelector('.upcoming_swiper_sub');  // スライドの数によっては存在しない可能性あり。

  if (swipeContentMain) {

    const slidesCountMain = swipeContentMain.querySelectorAll('.swiper-slide').length;  // スライドの数を取得
    // const slidesCountSub = swipeContentSub.querySelectorAll('.swiper-slide').length;  // スライドの数を取得

    const initSwiper = () => {
      swiperUpcomingSub = new Swiper('.upcoming_swiper_sub', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
      });

      swiperUpcomingMain = new Swiper('.upcoming_swiper_main', { // eslint-disable-line @typescript-eslint/no-unused-vars
        slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 2000, // スライドアニメーションのスピード（ミリ秒）
        initialSlide: 0, // スライドの開始インデックス番号
        centeredSlides: false,
        loop: true,  // スライドが3つ以上の場合のみループを有効にする
        loopAdditionalSlides: 1,
        spaceBetween: 0,
        grabCursor: false, // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: false, // スライドの進行状況を監視する / 重くなるので使わない場合はfalse推奨
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化
        parallax: true,
        longSwipes: true,
        longSwipesRatio: .1,
        autoplay: {
          delay: 8000,  // 自動再生の間隔
          pauseOnMouseEnter: true, // マウスを乗せている間は自動再生を止める（true）
          disableOnInteraction: false,  // 一度でも操作すると自動再生を止める（true）
        },
      });

      swiperUpcomingMain.controller.control = [swiperUpcomingSub];
      swiperUpcomingSub.controller.control = [swiperUpcomingMain];
    };


    const destroySwiper = () => {
      if (swiperUpcomingMain && typeof swiperUpcomingMain.destroy === 'function') {
        swiperUpcomingMain.destroy(true, true);
        swiperUpcomingMain = null;
      }

      if (swiperUpcomingSub && typeof swiperUpcomingSub.destroy === 'function') {
        swiperUpcomingSub.destroy(true, true);
        swiperUpcomingSub = null;
      }
    };

    const handleSwiper = () => {
      destroySwiper();

      if (!swiperUpcomingMain) {
        if (slidesCountMain > 1) {
          initSwiper();
        }
      }
    };

    handleSwiper();
  }
}

